import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { messageService } from "../../services/message.service";
import { messageWidgetService } from "../../services/message-widget.service";

export const queryMessageBySessionId = createAsyncThunk(
  "messageManage/queryMessageBySessionId",
  async ({ sessionId, filter }, { rejectWithValue }) => {
    try {
      const response = await messageService.queryMessageBySessionId(
        sessionId,
        filter
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const queryMessageWidgetBySessionId = createAsyncThunk(
  "messageManage/queryMessageWidgetBySessionId",
  async ({ sessionId, filter, domain }, { rejectWithValue }) => {
    try {
      const response = await messageWidgetService.queryMessageWidgetBySessionId(
        sessionId,
        filter,
        domain
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendMessageWidget = createAsyncThunk(
  "messageManage/sendMessageWidget",
  async ({ data, isFormData, domain }, { rejectWithValue }) => {
    try {
      const response = await messageWidgetService.sendMessageWidget(
        data,
        isFormData,
        domain
      );

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendMessage = createAsyncThunk(
  "messageManage/sendMessage",
  async ({ data, isFormData }, { rejectWithValue }) => {
    try {
      const response = await messageService.sendMessage(data, isFormData);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editMessage = createAsyncThunk(
  "messageManage/editMessage",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await messageService.editMessage(id, data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const readMessage = createAsyncThunk(
  "messageManage/readMessage",
  async (id, { rejectWithValue }) => {
    try {
      const response = await messageService.readMessage(id);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
